import React from 'react';
import clsx from 'clsx';
import styles from './link-button.module.scss';

export interface LinkButtonProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  variant?: 'primary' | 'secondary';
}

export const LinkButton: React.FC<LinkButtonProps> = ({ className, children, variant = 'primary', ...rest }) => {
  const linkButtonStyle = `${variant}LinkButton`;

  return (
    <a {...rest} className={clsx(styles[linkButtonStyle], className)}>
      {children}
    </a>
  );
};

export default LinkButton;
